import React, { useState } from 'react'
import './edit-extension-new.css'

const NoteAChat = ({ todo, updateTodo }) => {

  const [open, setOpen] = useState("notes")
  const [noteValue, setNoteValue] = useState(null)


  return (
    <div className="ee-note-container">
      <textarea
        className="ee-note-textarea"
        defaultValue={todo.description}
        onChange={e => updateTodo({ description: e.target.value })}
        placeholder="Add notes or details here..."
        rows={18}
      />
    </div>
  )
}
export default NoteAChat



